import React, { useEffect, useState } from "react";
import { Button } from "../../styles";
import { HiMiniArrowTopRightOnSquare } from "react-icons/hi2";
import { CgArrowTopRight } from "react-icons/cg";
import { GoProjectSymlink } from "react-icons/go";
import { colors, theme } from "../../styles/theme";
import { styled, keyframes } from "styled-components";
import { scrollIntoViewWithOffset } from "../../services/scroll.service";

const IntroSection = () => {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      style={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        // minHeight: 500,
        // paddingTop: "80px", // Add padding to prevent navigation overlap
      }}
    >
      <TopSectionContainer style={{ transform: `translateY(${scrollY * 0.3}px)` }}>
        <GradientOverlay />
        
        {/* Floating decorative elements */}
        <FloatingCircle
          style={{
            top: "20%",
            right: "8%",
            width: "150px",
            height: "150px",
            animationDelay: "0s",
          }}
        />
        <FloatingCircle
          style={{
            top: "55%",
            right: "25%",
            width: "100px",
            height: "100px",
            animationDelay: "2s",
          }}
        />
        <FloatingCircle
          style={{
            bottom: "15%",
            right: "12%",
            width: "80px",
            height: "80px",
            animationDelay: "4s",
          }}
        />
        
        {/* Grid pattern overlay */}
        <GridPattern />
        
        <ContentWrapper>
          <CatchParagraph data-aos="fade-right" data-aos-delay="100">
            Cwin Technology Solutions is a global provider of digital services,
            <br />
            offering innovative solutions to enhance all your technological
            needs.
          </CatchParagraph>
          <CatchPhrase data-aos="fade-right" data-aos-delay="200">
            The best way to predict
            <br /> the future is to invent it
          </CatchPhrase>
          <ButtonWrapper data-aos="fade-left" data-aos-delay="300">
            <Button
              props={{
                bakground: "white",
                hover: "#36383C",
                hoverColor: "white",
              }}
              style={{ fontWeight: "normal" }}
              onClick={() => scrollIntoViewWithOffset(`#about`, 0)}
            >
              Learn More <HiMiniArrowTopRightOnSquare />
            </Button>
          </ButtonWrapper>
        </ContentWrapper>
      </TopSectionContainer>
      <BottomSectionContainer>
        <StatCard data-aos="fade-up" data-aos-delay="100">
          <BadgeTag>TEAM</BadgeTag>
          <StatNumber>10 +</StatNumber>
          <StatDescription>
            Employees all over the world
            <IconCircle color={colors.primary}>
              <CgArrowTopRight size={22} color="white" />
            </IconCircle>
          </StatDescription>
        </StatCard>

        <StatCard data-aos="fade-up" data-aos-delay="200">
          <StatNumber>100 +</StatNumber>
          <StatDescription>
            Trusted Clients Internationally
            <IconCircle color={colors.secondary}>
              <GoProjectSymlink size={22} color={colors.primary} />
            </IconCircle>
          </StatDescription>
        </StatCard>

        <StatCard
          data-aos="fade-up"
          data-aos-delay="300"
          $featured
        >
          <StatNumber $featured>25 +</StatNumber>
          <StatDescription $featured>
            International projects annually
            <IconCircle color="white">
              <GoProjectSymlink size={22} color={colors.primary} />
            </IconCircle>
          </StatDescription>
        </StatCard>
      </BottomSectionContainer>
    </div>
  );
};

// Animations
const pulse = keyframes`
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.05); }
`;

const float = keyframes`
  0%, 100% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-20px) rotate(180deg); }
`;

const shimmer = keyframes`
  0% { background-position: -1000px 0; }
  100% { background-position: 1000px 0; }
`;

const fadeInOut = keyframes`
  0%, 100% { opacity: 0.3; }
  50% { opacity: 0.6; }
`;

// Styled Components
const TopSectionContainer = styled.div`
  position: relative;
  flex: 0.7;
  width: 100%;
  border-radius: 50px;
  background: ${`url(${require("../../assets/images/home-background.jpeg")})`};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  overflow: hidden;
  display: flex;
  align-items: flex-end;
  transition: transform 0.3s ease-out;

  @media (max-width: 768px) {
    flex: 1;
    padding-top: 100px;
    border-radius: 20px;
  }
`;

const GradientOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    135deg,
    rgba(0, 0, 0, 0.6) 0%,
    rgba(54, 56, 60, 0.4) 50%,
    rgba(0, 0, 0, 0.7) 100%
  );
  backdrop-filter: blur(2px);
  z-index: 1;
`;

const FloatingCircle = styled.div`
  position: absolute;
  border-radius: 50%;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.1),
    rgba(255, 255, 255, 0.05)
  );
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  animation: ${float} 6s ease-in-out infinite;
  z-index: 1;
  pointer-events: none;

  @media (max-width: 768px) {
    display: none;
  }
`;

const GridPattern = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: 
    linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px);
  background-size: 50px 50px;
  animation: ${fadeInOut} 4s ease-in-out infinite;
  z-index: 1;
  pointer-events: none;

  @media (max-width: 768px) {
    background-size: 30px 30px;
  }
`;

const ContentWrapper = styled.div`
  flex: 1;
  padding: 5%;
  position: relative;
  z-index: 2;
`;

const CatchParagraph = styled.p`
  color: rgba(255, 255, 255, 0.95);
  font-size: 18px;
  line-height: 1.7;
  letter-spacing: 0.3px;
  margin-bottom: 2rem;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);

  @media (max-width: 768px) {
    font-size: 15px;
    line-height: 1.6;
  }
`;

const CatchPhrase = styled.p`
  background: linear-gradient(
    135deg,
    #ffffff 0%,
    #e0e0e0 50%,
    #ffffff 100%
  );
  background-size: 200% auto;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-size: 56px;
  font-weight: 600;
  line-height: 1.2;
  letter-spacing: -1px;
  margin: 1.5rem 0 2.5rem;
  text-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
  animation: ${shimmer} 8s linear infinite;

  @media (max-width: 768px) {
    font-size: 35px;
    letter-spacing: -0.5px;
  }
`;

const ButtonWrapper = styled.div`
  button {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
    }

    &:active {
      transform: translateY(0);
    }
  }
`;

const BottomSectionContainer = styled.div`
  flex: 0.3;
  width: 100%;
  padding: 1.5%;
  display: flex;
  gap: 1.5%;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 15px;
  }
`;

const StatCard = styled.div<{ $featured?: boolean }>`
  width: 32%;
  border-radius: 30px;
  background: ${props => props.$featured 
    ? `linear-gradient(135deg, ${colors.primary} 0%, #2a2c2f 100%)`
    : 'rgba(237, 237, 238, 0.8)'
  };
  backdrop-filter: blur(10px);
  padding: 2.5%;
  display: flex;
  flex-direction: column;
  position: relative;
  border: ${props => props.$featured 
    ? '1px solid rgba(255, 255, 255, 0.1)'
    : '1px solid rgba(255, 255, 255, 0.5)'
  };
  box-shadow: ${props => props.$featured
    ? '0 8px 32px rgba(54, 56, 60, 0.3)'
    : '0 4px 16px rgba(0, 0, 0, 0.08)'
  };
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${props => props.$featured
      ? 'linear-gradient(135deg, rgba(255,255,255,0.1) 0%, transparent 100%)'
      : 'linear-gradient(135deg, rgba(255,255,255,0.5) 0%, transparent 100%)'
    };
    opacity: 0;
    transition: opacity 0.4s ease;
  }

  &:hover {
    transform: translateY(-8px);
    box-shadow: ${props => props.$featured
      ? '0 12px 48px rgba(54, 56, 60, 0.4)'
      : '0 8px 32px rgba(0, 0, 0, 0.12)'
    };

    &::before {
      opacity: 1;
    }
  }

  @media (max-width: 768px) {
    width: 100%;
    padding: 5%;
  }
`;

const BadgeTag = styled.span`
  position: absolute;
  top: 10%;
  right: 4%;
  border-radius: 15px;
  border: 1px solid ${colors.primary};
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 1px;
  padding: 6px 12px;
  color: ${colors.primary};
  animation: ${pulse} 3s ease-in-out infinite;
`;

const StatNumber = styled.p<{ $featured?: boolean }>`
  font-size: 72px;
  font-weight: 300;
  margin: 0;
  flex: 1;
  display: flex;
  align-items: center;
  font-family: "NeueHaasDisplay-Light", sans-serif;
  color: ${props => props.$featured ? 'white' : colors.primary};
  letter-spacing: -2px;
  background: ${props => props.$featured
    ? 'linear-gradient(135deg, #ffffff 0%, #e0e0e0 100%)'
    : 'none'
  };
  ${props => props.$featured && `
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  `}
  transition: transform 0.3s ease;

  ${StatCard}:hover & {
    transform: scale(1.05);
  }

  @media (max-width: 768px) {
    font-size: 56px;
  }
`;

const StatDescription = styled.div<{ $featured?: boolean }>`
  text-transform: capitalize;
  color: ${props => props.$featured ? 'rgba(255,255,255,0.95)' : theme.color};
  display: flex;
  align-items: flex-end;
  font-size: 15px;
  line-height: 1.4;
  font-weight: 500;
  letter-spacing: 0.2px;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

const IconCircle = styled.span<{ color: string }>`
  margin-left: auto;
  border-radius: 50%;
  background-color: ${props => props.color};
  height: 35px;
  width: 35px;
  min-width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

  ${StatCard}:hover & {
    transform: rotate(45deg) scale(1.1);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  }
`;

export default IntroSection;
